<template>
  <div class="game-frame">
    <!-- Will contain the canvas to render the app -->
    <StageFrame />

    <!-- Will contain the overlay -->
    <OverlayFrame ref="overlay"/>

    <!-- Will Contain all the UI subcomponents -->
    <UIFrame />
  </div>
</template>

<script>
import StageFrame from '@/components/StageFrame.vue';
import OverlayFrame from '@/components/OverlayFrame.vue';
import UIFrame from '@/components/UIFrame.vue';

export default {
  name: 'GameFrame',

  components: {
    StageFrame,
    OverlayFrame,
    UIFrame,
  },
};
</script>

<style lang="scss" scoped>
.game-frame {
  @include full(true);

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
